import { render, staticRenderFns } from "./InteractionButton.vue?vue&type=template&id=fde871ee&scoped=true"
import script from "./InteractionButton.vue?vue&type=script&lang=js"
export * from "./InteractionButton.vue?vue&type=script&lang=js"
import style0 from "./InteractionButton.vue?vue&type=style&index=0&id=fde871ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde871ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde871ee')) {
      api.createRecord('fde871ee', component.options)
    } else {
      api.reload('fde871ee', component.options)
    }
    module.hot.accept("./InteractionButton.vue?vue&type=template&id=fde871ee&scoped=true", function () {
      api.rerender('fde871ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/InteractionButton.vue"
export default component.exports